import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/biometric")({
  component: BiometricNoticePage,
});

function BiometricNoticePage() {
  return (
    <div className="flex flex-col items-center justify-center min-h-[60vh] text-center px-4">
      <h1 className="text-2xl font-semibold mb-4">Biometric Attendance</h1>
      <p className="text-muted-foreground max-w-md">
        Biometric attendance check requires the Unizen Android app connected to
        NCU Wi-Fi or your own OpenVPN.
      </p>
    </div>
  );
}
